import {useContext} from 'react'

import Context from '@s-ui/react-context'
import MoleculeNotification, {
  moleculeNotificationAutoClose,
  moleculeNotificationBorderSizes,
  moleculeNotificationTypes
} from '@s-ui/react-molecule-notification'

const NotificationAdNotAvailable = () => {
  const {domain, i18n} = useContext(Context)
  const config = domain.get('config')
  const APP_NAME = config.get('APP_NAME')

  return (
    <MoleculeNotification
      autoClose={moleculeNotificationAutoClose.manual}
      roundedCorners={moleculeNotificationBorderSizes.medium}
      type={moleculeNotificationTypes.system}
    >
      <div>
        <strong>{i18n.t('COMMON.AD_NOT_AVAILABLE_TITLE_NOTIFICATION')}</strong>
        <br />
        {i18n.t(`AD_NOT_AVAILABLE_SUBTITLE_NOTIFICATION_${APP_NAME}`)}
      </div>
    </MoleculeNotification>
  )
}

export default NotificationAdNotAvailable
